<div class="electricity-meter-selection">
  <label class="title">{{ 'module.shared.buildingEfficiencyWizard.step2.titleText' | translate }}</label
  ><br />
  <label class="period">{{ 'module.shared.buildingEfficiencyWizard.step2.periodText' | translate }} {{ startDate }} - {{ endDate }}</label>

  <div class="question-part">
    <div class="info-text-container">
      <div class="info-text">
        <span class="text">{{ 'module.shared.buildingEfficiencyWizard.step2.labelText' | translate }}</span>
      </div>
      <div class="toggle-container-top">
        <span *ngIf="getToggleVisibility()" class="toggle-text">{{ 'module.shared.buildingEfficiencyWizard.step2.toggleText' | translate }}</span>

        <div *ngIf="getToggleVisibility()" class="toggle-container">
          <span class="toggle">
            <span class="fa fa-info-circle" matTooltip="{{ note }}" matTooltipPosition="above" matTooltipClass="matTooltip-electricity-meter-selection"> </span>

            <mat-slide-toggle
              class="edit-toggle"
              [color]="color"
              [ngModel]="electricityMeterSelection.isConsumptionAutoSuggested | async"
              [checked]="electricityMeterSelection.isConsumptionAutoSuggested | async"
              (change)="onToggleChange($event.checked, false)"
            >
            </mat-slide-toggle>
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="multiple-meters-text" *ngIf="meters.length > 1">
    {{ 'module.shared.buildingEfficiencyWizard.step2.multipleMetersText' | translate }}
  </div>

  <ng-container *ngIf="meterTemplateConfig === electricityMeterConfig.none; else elseTemplate">
    <div *ngFor="let item of electricityMeterSelection.meters | async">
      <div>
        <span>{{ item.meter.objectType }}</span>
        <mat-form-field>
          <input
            [(ngModel)]="item.value"
            (ngModelChange)="update($event, item)"
            (change)="change($event)"
            matInput
            type="text"
            maxlength="6"
            (focus)="focus($event)"
            (blur)="blur($event)"
            (keypress)="onKeyPress($event, item)"
          />
        </mat-form-field>
        <span> kWh </span>
      </div>
    </div>
  </ng-container>
  <ng-template #elseTemplate>
    <div class="electricity-form">
      <div>
        <div *ngFor="let item of electricityMeterSelection.meters | async" class="meter-consumption">
          <div class="meter-checkbox-div">
            <mat-checkbox
              *ngIf="meterTemplateConfig === electricityMeterConfig.multiple"
              class="meter-checkbox"
              [(ngModel)]="item.isSelected"
              (ngModelChange)="updateCheckbox()"
              >{{ item.meter.objectTypeObj.name }}</mat-checkbox
            >
          </div>
          <div class="meter-types">
            <span>{{ 'module.shared.buildingEfficiencyWizard.step2.nummer' | translate }}</span
            ><br />
            <span>{{ item.meter.meterNumber | noLeadingZero }}</span>
          </div>
          <div class="meter-input">
            <mat-form-field>
              <input
                [(ngModel)]="item.value"
                (ngModelChange)="update($event, item)"
                (change)="change($event)"
                matInput
                type="text"
                maxlength="6"
                (focus)="focus($event)"
                (blur)="blur($event)"
                (keypress)="onKeyPress($event, item)"
              />
            </mat-form-field>
            <span> kWh </span>
            <span
              class="fa fa-info-circle"
              *ngIf="item.meter.message"
              matTooltip="{{ item.meter.message ? item.meter.message : '' }}"
              [matTooltipDisabled]="!item.meter.message"
              matTooltipPosition="above"
            >
            </span>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <div *ngIf="meterTemplateConfig === electricityMeterConfig.multiple" class="summation">
    <label class="text">{{ 'module.shared.buildingEfficiencyWizard.step2.sumText' | translate }}</label>
    <label class="value">{{ sum | localNumber }} kWh</label>
    <div>
      <label>{{ 'module.shared.buildingEfficiencyWizard.footerText' | translate }}</label>
    </div>
  </div>
  <div *ngIf="meterTemplateConfig !== electricityMeterConfig.multiple" class="footer">
    <label>{{ 'module.shared.buildingEfficiencyWizard.footerText' | translate }}</label>
  </div>
</div>
